<template>
    <div>
        <modal :show.sync="addItem" headerClasses="justify-content-center">
            <h6 slot="header" class="title title-up">Agregar ítem</h6>
                <form @submit.prevent="addItemToList()" data-vv-scope="addItem">
                    <div class="form-group">
                        <label>Concepto *</label>
                        <fg-input   tabindex="1"
                                    type="text"
                                    name="concepto"
                                    placeholder="concepto"
                                    autocomplete="off"
                                    v-validate="modelValidations.item_name"
                                    :error="getError('addItem.concepto')"
                                    v-model="itemName">
                        </fg-input>
                    </div>
                    <div class="form-group">
                        <label>Nro días producción en el mes *</label>
                        <fg-input   tabindex="2"
                                    type="number"
                                    name="número de días"
                                    placeholder="número de días"
                                    autocomplete="off"
                                    v-validate="modelValidations.item_days"
                                    :error="getError('addItem.número de días')"
                                    v-model="itemDays">
                        </fg-input>
                    </div>
                    <div class="form-group" v-for="(month, index) in itemMonths" :key="index">
                        <label>{{ month.name }} * </label>
                        <fg-input 
                            :tabindex="2+index"
                            type="number"
                            :name="month.name"
                            placeholder="número unidades producidas en el dia"
                            autocomplete="off"
                            v-validate="modelValidations.item_months"
                            :error="getError('addItem.' + month.name)"
                            v-model="month.unity"
                            @input="updateMonthValue(month)">
                        </fg-input>
                        <div v-if="month.total != 0" class="alert alert-warning mt-2">
                            <span>Total: {{ setFormat(month.total) }}</span>
                        </div>
                    </div>
                </form>
            <template slot="footer">
                <div class="left-side">
                <p-button type="default" link @click="cancelAddItem()">Cancelar</p-button>
                </div>
                <div class="divider"></div>
                <div class="right-side">
                <p-button type="default" link @click="addItemToList()">Agregar</p-button>
                </div>
            </template>
        </modal>
        <modal :show.sync="editItem" headerClasses="justify-content-center">
            <h6 slot="header" class="title title-up">Editar ítem</h6>
                <form @submit.prevent="editItemToList()" data-vv-scope="editItem">
                    <div class="form-group">
                        <label>Concepto *</label>
                        <fg-input   tabindex="1"
                                    type="text"
                                    name="concepto"
                                    placeholder="concepto"
                                    autocomplete="off"
                                    v-validate="modelValidations.item_name"
                                    :error="getError('editItem.concepto')"
                                    v-model="itemName">
                        </fg-input>
                    </div>
                    <div class="form-group">
                        <label>Nro días producción en el mes *</label>
                        <fg-input   tabindex="2"
                                    type="number"
                                    name="número de días"
                                    placeholder="número de días"
                                    autocomplete="off"
                                    v-validate="modelValidations.item_days"
                                    :error="getError('editItem.número de días')"
                                    v-model="itemDays">
                        </fg-input>
                    </div>
                    <div class="form-group" v-for="(month, index) in itemMonths" :key="index">
                        <label>{{ month.name }} * </label>
                        <fg-input 
                            :tabindex="2+index"
                            type="number"
                            :name="month.name"
                            placeholder="número unidades producidas en el dia"
                            autocomplete="off"
                            v-validate="modelValidations.item_months"
                            :error="getError('editItem.' + month.name)"
                            v-model="month.unity"
                            @input="updateMonthValue(month)">
                        </fg-input>
                        <div v-if="month.total != 0" class="alert alert-warning mt-2">
                            <span>Total: {{ setFormat(month.total) }}</span>
                        </div>
                    </div>
                </form>
            <template slot="footer">
                <div class="left-side">
                <p-button type="default" link @click="cancelEditItem()">Cancelar</p-button>
                </div>
                <div class="divider"></div>
                <div class="right-side">
                <p-button type="default" link @click="editItemToList()">Editar</p-button>
                </div>
            </template>
        </modal>
        <modal :show.sync="addProduct" headerClasses="justify-content-center">
            <h6 slot="header" class="title title-up">Agregar producto / animal</h6>
                <form @submit.prevent="addProductToList()" data-vv-scope="addProduct">
                    <div class="form-group">
                        <label>Producto / Animal *</label>
                        <fg-input   tabindex="1"
                                    type="text"
                                    name="producto / animal"
                                    placeholder="producto / animal"
                                    autocomplete="off"
                                    v-validate="modelValidations.seasonalName"
                                    :error="getError('addProduct.producto / animal')"
                                    v-model="seasonalName">
                        </fg-input>
                    </div>
                    <div class="form-group">
                        <label>Valor unidad *</label>
                        <vue-numeric  :max=999999999 tabindex="2" currency="$" autocomplete="off" name="valor unidad" v-validate="modelValidations.seasonalValue" :error="getError('addProduct.valor unidad')" separator="." class="form-control" v-model="seasonalValue"></vue-numeric>
                        <span v-show="errors.has('addProduct.valor unidad')" class="text-danger" style="font-size: 11px;">
                            {{ errors.first('addProduct.valor unidad') }}
                        </span>
                    </div>
                </form>
            <template slot="footer">
                <div class="left-side">
                <p-button type="default" link @click="cancelAddProduct()">Cancelar</p-button>
                </div>
                <div class="divider"></div>
                <div class="right-side">
                <p-button type="default" link @click="addProductToList()">Agregar</p-button>
                </div>
            </template>
        </modal>
        <modal :show.sync="editProduct" headerClasses="justify-content-center">
            <h6 slot="header" class="title title-up">Editar producto / animal</h6>
                <form @submit.prevent="editProductToList()" data-vv-scope="editProduct">
                    <div class="form-group">
                        <label>Producto / Animal *</label>
                        <fg-input   tabindex="1"
                                    type="text"
                                    name="producto / animal"
                                    placeholder="producto / animal"
                                    autocomplete="off"
                                    v-validate="modelValidations.seasonalName"
                                    :error="getError('editProduct.producto / animal')"
                                    v-model="seasonalName">
                        </fg-input>
                    </div>
                    <div class="form-group">
                        <label>Valor unidad *</label>
                        <vue-numeric  :max=999999999 tabindex="2" currency="$" autocomplete="off" name="valor unidad" v-validate="modelValidations.seasonalValue" :error="getError('editProduct.valor unidad')" separator="." class="form-control" v-model="seasonalValue"></vue-numeric>
                        <span v-show="errors.has('editProduct.valor unidad')" class="text-danger" style="font-size: 11px;">
                            {{ errors.first('editProduct.valor unidad') }}
                        </span>
                    </div>
                </form>
            <template slot="footer">
                <div class="left-side">
                <p-button type="default" link @click="cancelEditProduct()">Cancelar</p-button>
                </div>
                <div class="divider"></div>
                <div class="right-side">
                <p-button type="default" link @click="editProductToList()">Editar</p-button>
                </div>
            </template>
        </modal>
        <div class="col-md-12 mb-2">
                <h4 class="title center-title">Hoja de trabajo</h4>
        </div>
        <!-- Yields -->
        <card v-if="!addYieldInformation" class="form-horizontal">
            <div class="card-header">
                <h6 class="card-title">PROYECCIÓN DE VENTAS ESTACIONALES</h6>
            </div>
            <div class="card-body">
                <el-table @expand-change="handleExpandChange" v-if="products.length" :data="products"  ref="productsTable"  highlight-current-row @current-change="handleCurrentChange">
                    <el-table-column type="expand">
                        <template slot-scope="props">
                            <p>Producto / Animal: {{ props.row.seasonalName }}</p>
                            <p>Valor : {{ setFormat(props.row.seasonalValue) }}</p>
                            <el-table @expand-change="handleItemExpandChange" ref="itemsTable"  highlight-current-row @current-change="handleCurrentItemChange" v-if="props.row.seasonalItems.length > 0" :data="props.row.seasonalItems">
                                <el-table-column type="expand">
                                    <template slot-scope="props">
                                        <p>Concepto: {{ props.row.itemName }}</p>
                                        <p>Número de días producción en el mes : {{ props.row.itemDays }}</p>
                                        <p>Información meses:</p>
                                        <ul>
                                            <li v-for="(month, index) in props.row.itemMonths" :key="index">
                                                <strong>{{ month.name }}</strong>: 
                                                {{ month.unity !== null ? month.unity + ' Unidad(es)' : 'Sin unidades' }},
                                                Total: {{ month.total !== '' ? setFormat(month.total) : 'Sin valor calculado' }}
                                            </li>
                                        </ul>
                                    </template>
                                </el-table-column>
                                <el-table-column label="Concepto" property="itemName"></el-table-column>
                            </el-table>
                            <br>
                            <div>
                                <p-button 
                                    v-if="props.row.seasonalItems.length < 10"
                                    @click="addItemMethod(props.$index, props.row)"
                                    type="default" 
                                    >
                                    <i class="mr-2 fa fa-plus"></i>Agregar ítem
                                </p-button>
                            </div>
                            <br>
                            <div v-if="currentItemRow">
                                <p-button 
                                    @click="editItemMethod(props.$index, props.row)"
                                    type="default" >
                                    <i class="mr-2 fa fa-pencil"></i>Editar ítem
                                </p-button>
                            </div>
                            <br>
                            <div v-if="currentItemRow">
                                <p-button 
                                    @click="removeItem(props.$index)"
                                    type="default" >
                                    <i class="mr-2 fa fa-minus"></i>Quitar ítem
                                </p-button>
                            </div>
                            <br> 
                        </template>
                    </el-table-column>
                    <el-table-column label="Producto / Animal" property="seasonalName"></el-table-column>
                    <el-table-column label="Valor">
                        <template slot-scope="scope">
                            <span >{{ setFormat(scope.row.seasonalValue )}}</span>
                        </template>
                    </el-table-column>
                </el-table>
                
                <div>
                    <p-button 
                        v-if="products.length < 5"
                        @click="addProductMethod()"
                        type="default" 
                        >
                        <i class="mr-2 fa fa-plus"></i>Agregar producto / animal
                    </p-button>
                    <br>
                    <p-button v-if="currentRow"
                        @click="editProductMethod()"
                        type="default" 
                        >
                        <i class="mr-2 fa fa-pencil"></i>Editar producto / animal
                    </p-button>
                    <br>
                    <p-button v-if="currentRow"
                        @click="removeProductMethod()"
                        type="default" 
                        >
                        <i class="mr-2 fa fa-minus"></i>Quitar producto / animal
                    </p-button>
                </div>
            </div>
            <div class="card-footer">
            </div>
        </card>
        <div v-if="!addYieldInformation" class="text-right">
            <p-button @click="saveData()" type="warning">Siguiente</p-button>
            <p-button @click="toMenu()" type="default" class="pull-left mb-3">Atrás</p-button>
        </div>
    </div>
</template>
<script>
    import Vue from 'vue'
    import swal from 'sweetalert2'
    import { Card, CardDark, Collapse, CollapseItem, Modal } from 'src/components/UIComponents'
    import PSwitch from 'src/components/UIComponents/Switch.vue'
    import VueNumeric from 'vue-numeric'
    import formatMoney from 'accounting-js/lib/formatMoney.js'
    import {Select, Option, Table, TableColumn, Button} from 'element-ui'
    import Expenses from 'src/util/Others/OperatingExpenses'
    import Taxes from 'src/util/Services/Taxes'
    import moment from 'moment'
    import { Tooltip } from 'element-ui'
    import { Validator } from "vee-validate";
    Vue.use(Select)
    Vue.use(Option)
    Vue.use(Table)
    Vue.use(TableColumn)
    Validator.extend('no_leading_zeros', {
        validate: (value) => {
            value = String(value).trim();

            // Permitir exactamente "0"
            if (value === '0') return true;

            // No permitir ceros a la izquierda (excepto "0" como único valor)
            if (/^0\d+/.test(value)) return false;

            // Rechazar números que son exactamente 0.0000 (o equivalentes)
            if (parseFloat(value) === 0) return false;

            // Debe ser un número válido (enteros o decimales positivos)
            return /^\d+(\.\d+)?$/.test(value);
        },
        getMessage: field => `${field} no debe tener ceros a la izquierda.`
    });
    export default {
        components: {
            Card,
            CardDark,
            PSwitch,
            VueNumeric,
            Collapse,
            CollapseItem,
            Modal,
            [Button.name]: Button,
            [Tooltip.name]: Tooltip,
        },
        data() {
        return {
            consolidatedProducts: null,
            term: null,
            cashFlowData: null,
            selectedRow: null, // Fila seleccionada
            selectedProduct: null, // Producto padre seleccionado
            selectedItemIndex: null, // Índice del ítem seleccionado
            form: {
                average_selection: '',
            },
            operatingSwitches: {
                expenses: false,
                inventory: false,
            },
            addYieldInformation: false,
            microcredit: false,
            consumer: false,
            pyme: false,
            expenses : [],
            addCropCycle: false,
            editCropCycle: false,
            addItem: false,
            editItem: false,
            addItemIndex: null,
            editItemIndex: null,
            actualExpenses: [],
            currentRow: null,
            currentItemRow: null,
            currentCropRow: null,
            addExpense: false,
            editExpense: false,
            addExpenseIndex: null,
            addProduct: false,
            editProduct: false,
            addProductIndex: null,
            monthlyNumber: '',
            expenseName: '',
            expenseValue: '',
            expenseLocked: false,
            productName: '',
            productQuantity: '',
            productCostUnity: '',
            productSaleUnity: '',
            productCostTotal: '',
            productMonthlyCost: '',
            seasonalName: '',
            seasonalValue: '',
            itemMonths: '',
            itemName: '',
            itemDays: '',
            inventoryValue: '',
            inventoryTotal: '',
            referenceDescription: '',
            skipWatch: false,
            products: [
                
            ],
            costs: [],
            average: {
                good_sale: '',
                bad_sale: '',
                regular_sale: '',
                average_sales: '',
                monthly_average_sales: ''
            },
            modelValidations: {
                seasonalName: {
                    required: true,
                    max: 30,
                    regex: /^[a-zA-ZáéíóúÁÉÍÓÚñÑ0-9 ]*$/
                },
                seasonalValue: {
                    required: true
                },
                item_name: {
                    required: true,
                    max:30,
                    regex: /^[a-zA-ZáéíóúÁÉÍÓÚñÑ0-9 ]*$/
                },
                item_days: {
                    required: true,
                    max: 2,
                    no_leading_zeros: true
                },
                item_months: {
                    required: false,
                    max: 4,
                    no_leading_zeros: true
                }

            },
        }
        },
        watch: {
            itemDays: function(newVal, oldVal){
                const index = this.products.indexOf(this.currentRow);
                console.log("📢 Actualizando itemMonths.total con nuevo valor:", newVal);

                if (!this.itemMonths || !Array.isArray(this.itemMonths)) {
                    console.warn("⚠️ itemMonths no está definido o no es un array.");
                    return;
                }

                if (!this.products[index]) {
                    console.warn("⚠️ Producto no encontrado para el índice:", index);
                    return;
                }

                const seasonalValue = parseFloat(this.products[index].seasonalValue);

                this.itemMonths.forEach(month => {
                    month.total = (parseFloat(month.unity) * parseFloat(newVal) * seasonalValue) || 0;
                });

                console.log("✅ itemMonths.total actualizado correctamente.");
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            'operatingSwitches.expenses': function (newVal, oldVal) {
                if (!newVal) {
                    this.actualExpenses = [];
                    for (let i=0; i<this.expenses.length;i++) {
                        this.actualExpenses.push({
                            id: this.expenses[i].id,
                            name: this.expenses[i].name,
                            value: 0,
                            locked: true
                        })
                    }
                }
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            'operatingSwitches.inventory': function (newVal, oldVal) {
                if (!newVal) {
                    this.products = []
                }
            },
        },
        computed: {
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            verifyNext () {
                if (!this.operatingSwitches.expenses && !this.operatingSwitches.inventory) {
                    return true
                }
                else if(this.operatingSwitches.expenses && this.operatingSwitches.inventory &&  this.allExpensesMonthlyCostComputed != 0 && this.totalInventory != 0) {
                    return true
                }
                else if(this.operatingSwitches.expenses  &&  this.allExpensesMonthlyCostComputed ) {
                    if(!this.operatingSwitches.inventory) {
                        return true
                    }
                }
                else if(this.operatingSwitches.inventory  &&  this.totalInventory ) {
                    if(!this.operatingSwitches.expenses) {
                        return true
                    }
                }
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            productCostTotalComputed() {
                var total = this.productQuantity * this.productSaleUnity;
                this.productCostTotal = total;
                return total;
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            totalInventory() {
                var sum = 0;
                for (let i = 0;i<this.products.length;i++) {
                    sum = sum + this.products[i].inventoryValue; 
                }
                return sum
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            productMonthlyCostComputed() {
                var total = 0;
                if (this.monthlyNumber != '') {
                    var total = this.productQuantity * this.productCostUnity * this.monthlyNumber;
                    this.productMonthlyCost = total;
                }
                return total;
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            allExpensesMonthlyCostComputed() {
                var sum = 0;
                for (let i=0;i<this.actualExpenses.length;i++) {
                    sum = sum + (this.actualExpenses[i].value);
                }
                return sum   
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            allCostsComputed() {
                return this.allExpensesMonthlyCostComputed
            }
        },
        methods: {
            addTotalUnityToItemMonths() {
                if (!this.consolidatedProducts) return;

                this.consolidatedProducts.forEach(product => {
                    product.seasonalItems.forEach(item => {
                        const itemDays = parseFloat(item.itemDays);

                        item.itemMonths.forEach(month => {
                            month.totalUnity = parseFloat(month.unity) * itemDays;
                        });
                    });
                });
            },
            consolidateSeasonalItems() {
                this.consolidatedProducts = this.products.map(product => {
                    const consolidatedMonths = {};

                    product.seasonalItems.forEach(item => {
                        const itemDays = parseFloat(item.itemDays);

                        item.itemMonths.forEach(month => {
                            const monthName = month.name;

                            if (!consolidatedMonths[monthName]) {
                                consolidatedMonths[monthName] = {
                                    name: monthName,
                                    unity: 0,
                                    total: 0
                                };
                            }

                            // const adjustedUnity = parseFloat(month.unity) * itemDays;
                            // const adjustedTotal = parseFloat(month.total);

                            // consolidatedMonths[monthName].unity += adjustedUnity;
                            // consolidatedMonths[monthName].total += adjustedTotal;

                            const monthUnityRaw = parseFloat(month.unity);
                            const adjustedUnity = (isNaN(monthUnityRaw) ? 0 : monthUnityRaw) * itemDays;

                            const monthTotalRaw = parseFloat(month.total);
                            const adjustedTotal = isNaN(monthTotalRaw) ? 0 : monthTotalRaw;

                            consolidatedMonths[monthName].unity += adjustedUnity;
                            consolidatedMonths[monthName].total += adjustedTotal;
                        });
                    });

                    // Convert the consolidated months object into an array
                    const seasonalConsolidated = Object.values(consolidatedMonths);

                    return {
                        ...product,
                        seasonalConsolidated
                    };
                });
            },

            // updatedCashFlowMonths(){
            //     let seasonalData = {}; // Almacena los datos organizados por mes y seasonalName
            //     let totalizedSeasonalSales = {}; // Almacena la consolidación total por seasonalName

            //     // Obtener los nombres de los meses válidos desde cashFlowData.months
            //     let validMonths = new Set(this.cashFlowData.months.map(m => m.name));

            //     // 1️⃣ PRIMER PASO: Recorrer seasonalSales y organizar los datos por mes
            //     this.products.forEach((seasonal, seasonalIndex) => {
            //     seasonal.seasonalItems.forEach(item => {
            //         item.itemMonths.forEach(monthEntry => {
            //         let monthName = monthEntry.name; // "Marzo/25", "Abril/25", etc.

            //         // Validamos si el mes existe en cashFlowData.months
            //         if (!validMonths.has(monthName)) return; // Si no está en la lista de meses válidos, lo ignoramos

            //         // Inicializamos la estructura de seasonalData si no existe el mes
            //         if (!seasonalData[monthName]) {
            //             seasonalData[monthName] = [];
            //         }

            //         // Agregamos la información de cada seasonal
            //         seasonalData[monthName].push({
            //             seasonalIndex: seasonalIndex,
            //             seasonalName: seasonal.seasonalName,
            //             unity: parseInt(monthEntry.unity), // Unidades
            //             total: parseInt(monthEntry.total) // Total de ventas
            //         });

            //         // 2️⃣ SEGUNDO PASO: Consolidamos los totales por cada seasonalName si el mes es válido
            //         if (!totalizedSeasonalSales[seasonalIndex]) {
            //             totalizedSeasonalSales[seasonalIndex] = { 
            //             seasonalName: seasonal.seasonalName, 
            //             unity: 0, 
            //             total: 0 
            //             };
            //         }

            //         totalizedSeasonalSales[seasonalIndex].unity += parseInt(monthEntry.unity);
            //         totalizedSeasonalSales[seasonalIndex].total += parseInt(monthEntry.total);
            //         });
            //     });
            //     });

            //     // 3️⃣ TERCER PASO: Asociar seasonalSales en cashFlowData.months
            //     let updatedMonths = JSON.parse(JSON.stringify(this.cashFlowData.months)); // Copia profunda
            //     updatedMonths.forEach(monthData => {
            //     let monthName = monthData.name; // "Marzo/25", "Abril/25", etc.

            //     // Inicializamos seasonalSales dentro del mes
            //     monthData.seasonalSales = seasonalData[monthName] || [];
            //     });
            //     this.cashFlowData.months = updatedMonths;
            //     this.cashFlowData.totalizedSeasonalSales = totalizedSeasonalSales;
            // },
            updatedCashFlowMonths() {
                console.log("📢 Actualizando ventas estacionales por mes...");

                let seasonalDataByMonth = {}; // Para almacenar seasonalSales agrupadas por mes
                let totalizedSeasonalSales = {}; // Consolidado total por seasonalName

                // Obtener los nombres de los meses válidos desde cashFlowData.months
                let validMonths = new Set(this.cashFlowData.months.map(m => m.name));

                // 1️⃣ Agrupar seasonalItems dentro de su respectivo seasonalSales
                this.products.forEach((seasonal, seasonalIndex) => {
                    seasonal.seasonalItems.forEach(item => {
                        item.itemMonths.forEach(monthEntry => {
                            let monthName = monthEntry.name; // Ejemplo: "Marzo/25"

                            // Verificamos si el mes es válido en cashFlowData.months
                            if (!validMonths.has(monthName)) return;

                            // Si el mes no existe en la estructura, inicializarlo
                            if (!seasonalDataByMonth[monthName]) {
                                seasonalDataByMonth[monthName] = {};
                            }

                            // Si el seasonalName aún no ha sido creado, inicializarlo
                            if (!seasonalDataByMonth[monthName][seasonal.seasonalName]) {
                                seasonalDataByMonth[monthName][seasonal.seasonalName] = {
                                    seasonalName: seasonal.seasonalName,
                                    unity: 0,
                                    total: 0
                                };
                            }

                            // Acumular valores de seasonalItems dentro de su seasonalSales
                            seasonalDataByMonth[monthName][seasonal.seasonalName].unity += parseInt(monthEntry.unity);
                            seasonalDataByMonth[monthName][seasonal.seasonalName].total += parseInt(monthEntry.total);

                            // 2️⃣ Consolidar totales por cada seasonalName en totalizedSeasonalSales
                            if (!totalizedSeasonalSales[seasonalIndex]) {
                                totalizedSeasonalSales[seasonalIndex] = { 
                                    seasonalName: seasonal.seasonalName, 
                                    unity: 0, 
                                    total: 0 
                                };
                            }

                            totalizedSeasonalSales[seasonalIndex].unity += parseInt(monthEntry.unity);
                            totalizedSeasonalSales[seasonalIndex].total += parseInt(monthEntry.total);
                        });
                    });
                });

                // 3️⃣ Asociar seasonalSales en cashFlowData.months con los valores consolidados
                let updatedMonths = JSON.parse(JSON.stringify(this.cashFlowData.months)); // Copia profunda

                updatedMonths.forEach(monthData => {
                    let monthName = monthData.name;

                    // Si hay datos en seasonalDataByMonth, convertirlos en array y asignarlos
                    monthData.seasonalSales = seasonalDataByMonth[monthName] ? 
                        Object.values(seasonalDataByMonth[monthName]) : 
                        [];
                });

                // Actualizar datos en cashFlowData
                this.cashFlowData.months = updatedMonths;
                this.cashFlowData.totalizedSeasonalSales = totalizedSeasonalSales;

                console.log("✅ Seasonal Sales actualizadas correctamente.");
            },

            generateSeasonalMonths(term) {
                const MAX_TERM = 24; // Máximo de 24 meses adicionales
                const limitedTerm = Math.min(term, MAX_TERM); // Limitar term al máximo permitido

                const currentDate = new Date(); // Fecha actual
                const currentMonth = currentDate.getMonth(); // Mes actual (0 = enero)
                const currentYear = currentDate.getFullYear(); // Año actual

                const monthNames = [
                    'Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio',
                    'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'
                ];

                // Crear los meses desde el actual hasta limitedTerm meses adicionales
                this.itemMonths = Array.from({ length: limitedTerm + 1 }, (_, i) => {
                    const totalMonths = currentMonth + i; // Índice del mes total
                    const year = currentYear + Math.floor(totalMonths / 12); // Ajustar el año
                    const monthIndex = totalMonths % 12; // Índice del mes en el rango 0-11

                    return {
                        name: `${monthNames[monthIndex]}/${year.toString().slice(-2)}`, // Mes/Año en formato corto
                        unity: '',
                        total: '',
                    };
                });
            },
            validateProductsData() {
                // Verifica si products es un array y no está vacío
                if (!Array.isArray(this.products) || this.products.length === 0) {
                    this.showNotificationError('No hay datos en la lista de productos.');
                    return false;
                }

                // Itera sobre cada producto para validar seasonalItems
                for (const product of this.products) {
                    if (
                        !product.seasonalItems || 
                        !Array.isArray(product.seasonalItems) || 
                        product.seasonalItems.length === 0
                    ) {
                        this.showNotificationError('El producto no contiene items.');
                        return false;
                    }

                    // Itera sobre cada historicalItem para validar itemCrops
                    for (const items of product.seasonalItems) {
                        if (
                            !Array.isArray(items.itemMonths) || 
                            items.itemMonths.length === 0
                        ) {
                            this.showNotificationError('Los ítems no contienen datos de meses.');
                            return false;
                        }
                    }
                }

                // Si todas las validaciones pasan
                return true;
            },
            cancelYields(){
                this.addYieldInformation = false;
                this.currentCropRow = null;
                this.selectedRow = null;
                this.selectedProduct = null;
                this.selectedItemIndex = null;
            },
            resetCrop (){
                this.yields= {
                    yieldName: '',
                    yieldPrevious: '',
                    yieldMinimum: '',
                    yieldMaximum: '',
                    yieldAvg: '',
                    yieldUnity: '',
                    yieldFamiliarConsumption: '',
                    yieldUnityForSale: '',
                    yieldSalePrice: '',
                    yieldSaleTotal: '',
                    yieldMonths: [],
                    yieldAssociate: '',
                    yieldAssociateMonths: []
                }
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
             addCropToList () {
                this.$validator.validateAll('addCropCycle').then(isValid => {
                    if(isValid){
                        // Verifica si selectedProduct, seasonalItems y itemCrops existen
                        if (this.selectedProduct && this.selectedProduct.seasonalItems[this.selectedItemIndex]) {
                            const itemCrops = this.selectedProduct.seasonalItems[this.selectedItemIndex].itemCrops;

                            // Asegúrate de que yields contiene datos
                            if (this.yields) {
                                // Realiza una copia de this.yields (para evitar alteraciones futuras)
                                const newCropData = { ...this.yields };

                                // Agrega la nueva información al array itemCrops
                                itemCrops.push(newCropData);

                                // Si quieres resetear this.yields después de agregarlo, puedes hacerlo
                                this.resetCrop();
                                this.addCropCycle = false;
                                this.showNotificationSuccess('Ciclo cultivo agregado correctamente');
                                this.errors.clear();
                            } else {
                                console.error('No hay datos para agregar');
                            }
                        } else {
                            console.error('No se encuentra producto seleccionado en el índice seleccionado');
                        }
                    }
                    else {
                        console.error('Error: Campos no diligenciados correctamente');
                        console.log('Errores de validación:', this.errors.items); // Muestra los errores específicos
                        this.errors.items.forEach(error => {
                            console.log(`Campo: ${error.field}, Mensaje: ${error.msg}`);
                        });
                        this.showNotificationError('Campos no diligenciados correctamente');
                    }
                })
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
             editCropToList () {
                this.$validator.validateAll('editCropCycle').then(isValid => {
                    if(isValid){
                        // Verifica si selectedProduct, seasonalItems y itemCrops existen
                        if (this.selectedProduct && this.selectedProduct.seasonalItems[this.selectedItemIndex]) {
                            var index = this.selectedProduct.seasonalItems[this.selectedItemIndex].itemCrops.indexOf(this.currentCropRow);
                            const itemCrops = this.selectedProduct.seasonalItems[this.selectedItemIndex].itemCrops;

                            // Asegúrate de que yields contiene datos
                            if (this.yields) {
                                // Realiza una copia de this.yields (para evitar alteraciones futuras)
                                const newCropData = { ...this.yields };

                                // Agrega la nueva información al array itemCrops
                                itemCrops[index] = newCropData;

                                // Si quieres resetear this.yields después de agregarlo, puedes hacerlo
                                this.resetCrop();
                                this.editCropCycle = false;
                                this.currentCropRow = null;
                                this.$refs.cropsTable.setCurrentRow();
                                this.showNotificationSuccess('Ciclo cultivo editado correctamente');
                                this.errors.clear();
                            } else {
                                console.error('No hay datos para agregar');
                            }
                        } else {
                            console.error('No se encuentra producto seleccionado en el índice seleccionado');
                        }
                    }
                    else {
                        console.error('Error: Campos no diligenciados correctamente');
                        console.log('Errores de validación:', this.errors.items); // Muestra los errores específicos
                        this.errors.items.forEach(error => {
                            console.log(`Campo: ${error.field}, Mensaje: ${error.msg}`);
                        });
                        this.showNotificationError('Campos no diligenciados correctamente');
                    }
                })
            },
            cancelAddCrop(){
                this.addCropCycle = false;
                this.resetCrop();
                this.errors.clear();
            },
            cancelEditCrop(){
                this.editCropCycle = false;
                this.currentCropRow = null;
                this.resetCrop();
                this.errors.clear();
                this.$refs.cropsTable.setCurrentRow();
            },
            updateMonthValue(month) {
                const index = this.products.indexOf(this.currentRow);
                if (month.unity) {
                    month.total = Math.round(month.unity * this.itemDays * this.products[index].seasonalValue);
                } else {
                    month.total = 0;
                }
            },

            addCropCycleMethod(){
                this.resetCrop();
                this.errors.clear();
                this.addCropCycle = true;
                this.currentCropRow = null;
                this.$refs.cropsTable.setCurrentRow();
            },
            editCropCycleMethod() {
                var index = this.selectedProduct.seasonalItems[this.selectedItemIndex].itemCrops.indexOf(this.currentCropRow);
                this.yields = this.selectedProduct.seasonalItems[this.selectedItemIndex].itemCrops[index];
                this.editCropCycle = true;
            },
            removeCropCycleMethod () {
                var index = this.selectedProduct.seasonalItems[this.selectedItemIndex].itemCrops.indexOf(this.currentCropRow);
                if (index !== -1) {
                    // Elimina el crop en el índice encontrado
                    this.selectedProduct.seasonalItems[this.selectedItemIndex].itemCrops.splice(index, 1);
                    this.currentCropRow = null;
                    this.resetCrop();
                    this.errors.clear();
                    this.showNotificationSuccess('Ciclo cultivo eliminado correctamente');
                } else {
                    console.error('No se encontró el ciclo cultivo en el sistema');
                }
            },
            toggleCard(fullRow) {
                const row = fullRow.row;
                // Encuentra el producto padre
                const product = this.products.find((p) =>
                    p.seasonalItems.includes(row)
                );

                if (product) {
                    // Encuentra el índice del ítem
                    const itemIndex = product.seasonalItems.indexOf(row);

                    // Actualiza los datos
                    this.selectedRow = row; // El ítem en sí
                    this.selectedProduct = product; // El producto padre
                    this.selectedItemIndex = itemIndex; // Índice del ítem
                } else {
                    // Limpia si no se selecciona nada
                    this.selectedRow = null;
                    this.selectedProduct = null;
                    this.selectedItemIndex = null;
                }
                this.currentRow = null;
                this.currentItemRow = null;
                this.addYieldInformation = true;
                const table = this.$refs.productsTable; // Referencia al el-table
                if (table) {
                    this.products.forEach((row) => {
                    table.toggleRowExpansion(row, false); // Contrae la fila
                    });
                }
            },
            handleExpandChange(row, expanded) {
                this.currentRow = row;
                this.currentItemRow = null;
            },
            handleItemExpandChange(row, expanded) {
                this.currentItemRow = row;
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
             removeItem (row) {
                this.products[row].seasonalItems.splice(this.products[row].seasonalItems.indexOf(this.currentItemRow),1);
                this.currentItemRow = null;
                this.resetItem();
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            resetItem () {
                this.itemName = '';
                this.itemDays = '';
                this.itemMonths = []
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
             cancelAddItem () {
                this.addItem = false;
                this.resetItem();
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            cancelEditItem () {
                this.editItem = false;
                this.resetItem();
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
             addItemToList () {
                this.$validator.validateAll('addItem').then(isValid => {
                    if(isValid){
                        this.products[this.addItemIndex].seasonalItems.push({
                            itemName: this.itemName,
                            itemDays: this.itemDays,
                            itemMonths: this.itemMonths
                        })
                        this.resetItem();
                        this.addItem = false;
                        this.addItemIndex = null;
                        this.showNotificationSuccess('Item agregado correctamente');
                    }
                    else {
                        console.error('Error: Campos no diligenciados correctamente');
                        console.log('Errores de validación:', this.errors.items); // Muestra los errores específicos
                        this.errors.items.forEach(error => {
                            console.log(`Campo: ${error.field}, Mensaje: ${error.msg}`);
                        });
                        this.showNotificationError('Campos no diligenciados correctamente');
                    }
                })
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            editItemToList () {
                this.$validator.validateAll('editItem').then(isValid => {
                    if(isValid){
                        var index = this.products[this.editItemIndex].seasonalItems.indexOf(this.currentItemRow);
                        this.products[this.editItemIndex].seasonalItems[index].itemName = this.itemName;
                        this.products[this.editItemIndex].seasonalItems[index].itemDays = this.itemDays;
                        this.products[this.editItemIndex].seasonalItems[index].itemMonths = this.itemMonths;
                        this.resetItem();
                        this.editItem = false;
                        this.editItemIndex = null;
                        this.currentItemRow = null;
                        this.$refs.itemsTable.setCurrentRow();
                        this.showNotificationSuccess('Item editado correctamente');
                    }
                    else {
                        console.error('Error: Campos no diligenciados correctamente');
                        console.log('Errores de validación:', this.errors.items); // Muestra los errores específicos
                        this.errors.items.forEach(error => {
                            console.log(`Campo: ${error.field}, Mensaje: ${error.msg}`);
                        });
                        this.showNotificationError('Campos no diligenciados correctamente');
                    }
                })
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
             addItemMethod (index,row) {
                this.generateSeasonalMonths(this.term);
                this.addItemIndex = index;
                this.addItem = true;
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
             editItemMethod (row) {
                this.editItemIndex = row;
                var index = this.products[row].seasonalItems.indexOf(this.currentItemRow);
                this.itemName= JSON.parse(JSON.stringify(this.products[row].seasonalItems[index].itemName));
                this.itemDays= JSON.parse(JSON.stringify(this.products[row].seasonalItems[index].itemDays));
                this.itemMonths= JSON.parse(JSON.stringify(this.products[row].seasonalItems[index].itemMonths));
                this.editItem = true;
            },
            toMenu () {
                this.$router.push('/asessments/menu');
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            productValidator (product) {
                if (this.$store.state.isCustomer) {
                    if (product.name.toLowerCase() == 'consumo') {
                        this.consumer = true;
                        this.microcredit = false;
                        if (this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].references.length != 0) {
                            this.products = this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].references;
                            
                        }
                    }
                    else if (product.name.toLowerCase() == 'microcrédito' || product.name.toLowerCase() == 'microcredito') {
                        this.microcredit = true;
                        this.consumer = false;
                        if (this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].costsPopulate && this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].references.length != 0) {
                            this.products = this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].references;
                            
                        }
                    }
                    else if (product.name.toLowerCase() == 'pequeña empresa') {
                        this.microcredit = false;
                        this.consumer = false;
                        this.pyme = true;
                        if (this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].costsPopulate && this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].references.length != 0) {
                            this.products = this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].references;
                            
                        }
                    }
                    
                }
                else if(this.$store.state.isSpouse) {
                    if (product.name.toLowerCase() == 'consumo') {
                        this.consumer = true;
                        this.microcredit = false;
                        if (this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].references.length != 0) {
                            this.products = this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].references;
                            
                        }
                    }
                    else if (product.name.toLowerCase() == 'microcrédito' || product.name.toLowerCase() == 'microcredito') {
                        this.microcredit = true;
                        this.consumer = false;
                        if (this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].costsPopulate && this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].references.length != 0) {
                            this.products = this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].references;
                            
                        }
                    }
                    else if (product.name.toLowerCase() == 'pequeña empresa') {
                        this.microcredit = false;
                        this.consumer = false;
                        this.pyme = true;
                        if (this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].costsPopulate && this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].references.length != 0) {
                            this.products = this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].references;
                            
                        }
                    }
                    
                }
                if (this.$store.state.isGuarantor) {
                    if (product.name.toLowerCase() == 'consumo') {
                        this.consumer = true;
                        this.microcredit = false;
                        if (this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].references.length != 0) {
                            this.products = this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].references;
                            
                        }
                    }
                    else if (product.name.toLowerCase() == 'microcrédito' || product.name.toLowerCase() == 'microcredito') {
                        this.microcredit = true;
                        this.consumer = false;
                        if (this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].costsPopulate && this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].references.length != 0) {
                            this.products = this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].references;
                            
                        }
                    }
                    else if (product.name.toLowerCase() == 'pequeña empresa') {
                        this.microcredit = false;
                        this.consumer = false;
                        this.pyme = false;
                        if (this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].costsPopulate && this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].references.length != 0) {
                            this.products = this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].references;
                            
                        }
                    }
                    
                }
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            handleCurrentChange(currentRow, oldCurrentRow) {
                this.currentRow = currentRow;
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
             handleCurrentItemChange(currentRow, oldCurrentRow) {
                this.currentItemRow = currentRow;
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
             handleCurrentCropChange(currentRow, oldCurrentRow) {
                this.currentCropRow = currentRow;
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            editExpenseToList () {
                if (this.expenseName == '') {
                    this.showNotificationError('El campo nombre de gasto no puede estar vacío');
                }
                else {
                    var index = this.actualExpenses.indexOf(this.currentRow);
                    this.actualExpenses[index].name = this.expenseName;
                    this.actualExpenses[index].value = this.expenseValue;
                    this.resetExpense();
                    this.currentRow = null;
                    this.$refs.expensesTable.setCurrentRow();
                    this.editExpense = false;
                    this.showNotificationSuccess('Gasto editado correctamente');
                }
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            addExpenseMethod (row) {
                // this.addProductIndex = row;
                this.addExpense = true;
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            addProductToList () {
                this.$validator.validateAll('addProduct').then(isValid => {
                    if(isValid){
                        this.products.push({
                            seasonalName: this.seasonalName,
                            seasonalValue: this.seasonalValue,
                            seasonalItems: []
                        })
                        this.resetProduct();
                        this.addProduct = false;
                        this.errors.clear();
                        this.showNotificationSuccess('Producto agregado correctamente');
                        }
                        else {
                            console.error('Error: Campos no diligenciados correctamente');
                            console.log('Errores de validación:', this.errors.items); // Muestra los errores específicos
                            this.errors.items.forEach(error => {
                                console.log(`Campo: ${error.field}, Mensaje: ${error.msg}`);
                            });
                            this.showNotificationError('Campos no diligenciados correctamente');
                        }
                })

            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            resetProduct () {
                this.seasonalName = '';
                this.seasonalValue = '';
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            editProductMethod () {
                this.seasonalName= this.currentRow.seasonalName;
                this.seasonalValue= this.currentRow.seasonalValue;
                this.editProduct = true;
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            removeProductMethod () {
                this.products.splice(this.products.indexOf(this.currentRow),1);
                this.currentRow = null;
                this.resetProduct()
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            editProductToList () {
                this.$validator.validateAll('editProduct').then(isValid => {
                    if(isValid){
                        var index = this.products.indexOf(this.currentRow);
                        this.products[index].seasonalName = this.seasonalName;
                        this.products[index].seasonalValue = this.seasonalValue;
                        this.resetProduct();
                        this.currentRow = null;
                        this.$refs.productsTable.setCurrentRow();
                        this.editProduct = false;
                        this.errors.clear();
                        this.showNotificationSuccess('Producto editado correctamente');
                    }
                    else {
                        console.error('Error: Campos no diligenciados correctamente');
                        console.log('Errores de validación:', this.errors.items); // Muestra los errores específicos
                        this.errors.items.forEach(error => {
                            console.log(`Campo: ${error.field}, Mensaje: ${error.msg}`);
                        });
                        this.showNotificationError('Campos no diligenciados correctamente');
                    }
                })
                
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            addProductMethod () {
                this.errors.clear();
                this.addProduct = true;
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            cancelAddProduct () {
                this.addProduct = false;
                this.errors.clear();
                this.resetItem();
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            cancelEditProduct () {
                this.editProduct = false;
                this.errors.clear();
                this.resetItem();
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            showNotificationError (message) {
                this.$notify(
                {
                    message: message,
                    icon: 'nc-icon nc-glasses-2',
                    horizontalAlign: 'center',
                    verticalAlign: 'top',
                    type: 'danger'
                })
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            showNotificationSuccess (message) {
                this.$notify(
                {
                    message: message,
                    icon: 'nc-icon nc-check-2',
                    horizontalAlign: 'center',
                    verticalAlign: 'top',
                    type: 'success'
                })
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            addExpenseToList () {
                if (this.expenseName == '') {
                    this.showNotificationError('El campo nombre de gasto no puede estar vacío');
                }
                else {
                    var id = this.actualExpenses.length + 1;
                    this.actualExpenses.push({
                        id: id,
                        name: this.expenseName,
                        value: this.expenseValue,
                        locked: false
                    })
                    this.resetExpense();
                    this.addExpense = false;
                    this.showNotificationSuccess('Gasto agregado correctamente');
                }
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            resetExpense () {
                this.expenseName = '';
                this.expenseValue = '';   
                this.expenseLocked = false;
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            editExpenseMethod () {
                this.expenseName= this.currentRow.name;
                this.expenseValue= this.currentRow.value;
                this.expenseLocked = this.currentRow.locked;
                this.editExpense = true;
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            removeExpenseMethod () {
                this.actualExpenses.splice(this.actualExpenses.indexOf(this.currentRow),1);
                this.currentRow = null;
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            cancelAddExpense () {
                this.addExpense = false;
                this.resetExpense();
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            cancelEditExpense () {
                this.editExpense = false;
                this.resetExpense();
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            setFormat (value) {
                return formatMoney(value, { symbol: "$", precision: 0, thousand: ".", decimal: "," });
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            getError (fieldName) {
                return this.errors.first(fieldName)
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            toSalesCostsSelection () {
                this.$router.push('/asessments/new_asessment/customer/sales_costs_selection');
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            toOperatingExpenses () {
                this.$router.push('/asessments/new_asessment/customer/others/operating_expenses');
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            toRequestData () {
                this.$router.push('/asessments/new_asessment/customer/request_data');
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
             saveData () {
                this.consolidateSeasonalItems();
                this.updatedCashFlowMonths();
                this.addTotalUnityToItemMonths();
                if (this.validateProductsData()) {
                    const payload = {
                        products: this.consolidatedProducts,
                        cashFlowData: this.cashFlowData
                    };
                    this.$store.dispatch('setAgroSeasonalSales', payload).then(()=>{
                        var vm = this;
                        const routes = [
                            {
                                title: '¿Deseas agregar Ingresos por jornales o salarios a la actividad agropecuaria?',
                                text: 'Si aceptas, podrás agregar o editar la información de Ingresos por jornales o salarios a la actividad agropecuaria',
                                route: '/asessments/new_asessment/customer/agro/salary'
                            }
                        ];
                        let currentIndex = 0;
                        function askRoute() {
                            if (currentIndex < routes.length) {
                                const current = routes[currentIndex];
                                swal({
                                    title: current.title,
                                    text: current.text,
                                    type: 'info',
                                    showCancelButton: true,
                                    confirmButtonText: 'Si, aceptar',
                                    cancelButtonText: 'No, continuar',
                                    confirmButtonClass: 'btn btn-success btn-fill',
                                    cancelButtonClass: 'btn btn-danger btn-fill',
                                    buttonsStyling: false
                                }).then(() => {
                                    vm.$router.push(current.route); // Redirige a la ruta correspondiente
                                }, (dismiss) => {
                                    if (dismiss === 'cancel') {
                                        currentIndex++; // Avanza al siguiente paso
                                        askRoute(); // Llama recursivamente para mostrar la siguiente pregunta
                                    } else {
                                        swal({
                                            title: 'Cancelado',
                                            text: 'El analista no ha continuado',
                                            type: 'error',
                                            confirmButtonClass: 'btn btn-info btn-fill',
                                            buttonsStyling: false
                                        });
                                    }
                                });
                            } else {
                                vm.$router.push('/asessments/new_asessment/customer/agro/expenses');
                            }
                        }
                        // Llama la función para iniciar el flujo
                        askRoute(); 
                    });
                }
            }
        },
        mounted () {
            this.$nextTick(() => {
                document.addEventListener('wheel', (event) => {
                if (event.target.type === 'number') {
                    event.preventDefault();
                }
                }, { passive: false });
            });
            if (this.$store.state.isCustomer) {
                if (this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].agroData.seasonalSales) {
                    this.products = this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].agroData.seasonalSales;
                }
                this.term = this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].agroData.cashFlow.clientTerm;
                this.generateSeasonalMonths(this.term);
                this.cashFlowData = this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].agroData.cashFlowData;
            }
            else if (this.$store.state.isSpouse) {
                if (this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].agroData.seasonalSales) {
                    this.products = this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].agroData.seasonalSales;
                }
                this.term = this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].agroData.cashFlow.clientTerm;
                this.generateSeasonalMonths(this.term);
                this.cashFlowData = this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].agroData.cashFlowData;
            }
            else if (this.$store.state.isGuarantor) {
                if (this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].agroData.seasonalSales) {
                    this.products = this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].agroData.seasonalSales;
                }
                this.term = this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].agroData.cashFlow.clientTerm;
                this.generateSeasonalMonths(this.term);
                this.cashFlowData = this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].agroData.cashFlowData;
            }
        }
    }
</script>
<style lang="scss">
// Estilos para poder centrar el título de el usuario
    .center-title {
        margin-top: 0;
        margin-bottom: 0;
    }
    /* Cambiar color del texto de los elementos seleccionados en el select */
    .select-warning .el-select__tags .el-tag {
        color: black; /* Cambia esto por el color que desees */
    }
</style>
